import "core-js/modules/es.array.sort.js";
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "popup-widget-wrapper"
};
const _hoisted_2 = ["src", "onClick"];
import constants from '@/constants';
import { useRoute, useRouter } from 'vue-router';
import { Bridge } from '@/utils/bridge';
import { useLess } from '@/models/hooks';
import { onMounted, watch, ref } from 'vue';
import { jumpInteractionType } from '@/utils/common';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { clickEvents } from '@/configs/awsRumConfig';
import { LANDING_PAGE_PARAMS_PAGE_TYPE } from '@/utils/landingPageCommon.js';
export default {
  __name: 'PopupWidget',
  props: {
    widgetList: {
      type: Array,
      require: true,
      default: () => {
        return [];
      }
    }
  },
  setup(__props) {
    const props = __props;
    useLess('views/landingPage/popupWidget/PopupWidget.less');
    const {
      IMAGE_URL
    } = constants;
    const route = useRoute();
    const router = useRouter();
    const popupWidgetIndex = ref(0);
    const popupWidgetList = ref([]);
    const deleteTranslucent = `${IMAGE_URL}/assets/svg/deleteTranslucent.svg`;
    const isShowPopup = ref(false);
    const onClose = () => {
      if (popupWidgetIndex.value + 1 < popupWidgetList.value.length) {
        popupWidgetIndex.value += 1;
      } else {
        isShowPopup.value = false;
      }
    };
    const onClickImg = () => {
      isShowPopup.value = false;
      jumpInteractionType(popupWidgetList.value[popupWidgetIndex.value].picInfo, router);
    };
    // Calculate whether the display pop-up conditions are met
    // pageType: [1, 2], // Launch page: 1- gateway 2- landingPage
    const canPopupShowOnPageType = pageType => {
      const pageTypeIndex = Object.keys(LANDING_PAGE_PARAMS_PAGE_TYPE).findIndex(item => {
        return item === route.name.toUpperCase();
      });
      return pageType.includes(pageTypeIndex + 1);
    };
    watch(() => props.widgetList, newVal => {
      const newWidgetList = newVal.filter(item => {
        item.enableTimeStamp = new Date(item.enableTime).getTime();
        return canPopupShowOnPageType(item.pageType);
      });
      popupWidgetList.value = newWidgetList.sort((a, b) => {
        return a.enableTimeStamp - b.enableTimeStamp;
      });
      if (popupWidgetList.value.length) {
        isShowPopup.value = true;
      }
    }, {
      deep: true,
      immediate: true
    });
    onMounted(() => {
      const recordParams = {
        pageName: route.name
      };
      awsRumHandler.recordClickEvent({
        ...clickEvents.landingPage.popupWidgetWidget,
        ...recordParams
      });
    });
    return (_ctx, _cache) => {
      var _popupWidgetList$valu, _popupWidgetList$valu2;
      return isShowPopup.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "popup-widget-container",
        onClick: onClose
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
        src: (_popupWidgetList$valu = popupWidgetList.value[popupWidgetIndex.value]) === null || _popupWidgetList$valu === void 0 ? void 0 : (_popupWidgetList$valu2 = _popupWidgetList$valu.picInfo) === null || _popupWidgetList$valu2 === void 0 ? void 0 : _popupWidgetList$valu2.pic,
        onClick: _withModifiers(onClickImg, ["stop"]),
        alt: ""
      }, null, 8, _hoisted_2), _createElementVNode("div", {
        class: "popup-widget-del-icon-box"
      }, [_createElementVNode("img", {
        src: deleteTranslucent,
        alt: ""
      })])])])) : _createCommentVNode("", true);
    };
  }
};